"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.resetModels = void 0;

var _dvaNoRouter = _interopRequireDefault(require("dva-no-router"));

var _dvaLoading = _interopRequireWildcard(require("./plugins/dva-loading"));

var _nbugsLogger = _interopRequireDefault(require("./plugins/nbugs-logger"));

var _models = _interopRequireDefault(require("../models"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app;

var installModels = function installModels() {
  _models.default.forEach(function (model) {
    app.model(model.default);
  });
};

var resetModels = function resetModels() {
  var namespaces = _models.default.map(function (model) {
    return model.default.namespace;
  });

  namespaces.forEach(function (namespace) {
    app._store.dispatch({
      type: "".concat(namespace, "/resetState")
    });
  });

  app._store.dispatch({
    type: "".concat(_dvaLoading.RESET)
  });
};

exports.resetModels = resetModels;

var _default = function _default(router) {
  app = (0, _dvaNoRouter.default)({
    onError: function onError() {}
  });
  app.use((0, _dvaLoading.default)());
  app.use((0, _nbugsLogger.default)());
  installModels(app);
  app.router(function () {
    return router;
  });
  var Provider = app.start();
  return {
    Provider: Provider,
    app: app
  };
};

exports.default = _default;